const md = `## Dokumentationsbibliothek

Willkommen in der **Dokumentationsbibliothek**!

Hier findest du alle wichtigen Informationen und Anleitungen zu unseren Projekten. Nutze diese Bibliothek, um dich über Funktionen, Abläufe und technische Details zu informieren. Alle Dokumentationen sind in Kapitel unterteilt, sodass du gezielt zu den Themen springen kannst, die dich interessieren.

Viel Spaß beim Lesen und Entdecken!`;

export default md;
